
  import { Vue, Component, Prop } from 'vue-property-decorator';
  import { Field, DropdownField } from '@samc/centricity-core';
  import { ServiceVendorSource } from '@/Sources';
  import { IOrganization } from '@/Interfaces';

  @Component({
    name: 'service-vendor-dropdown-field',
    components: { Field, DropdownField }
  })
  export default class ServiceVendorDropdownField extends Vue {
    @Prop() public value!: number;
    @Prop({ default: 'Vendor Name' }) public label!: string;
    @Prop({ type: Boolean, default: false }) public disabled!: boolean;
    @Prop({ type: Boolean, default: false }) public autoAssign!: boolean;
    @Prop({ type: Boolean, default: false }) public taggable!: boolean;
    @Prop({ default: '' }) public errorText!: string;
    @Prop() public placeholder!: string;

    public newInternalId = 0;
    public source: ServiceVendorSource = new ServiceVendorSource();

    public get val(): number { return this.value; }
    public set val(value: number) {
      this.$emit('input', value);
      this.$emit('organization', this.source.find(x => x.internalId === value) ?? null);
    }

    /**
     * Processor function to add a new vendor based on the tag shown
     * 
     * @param tag The type of tag we are working with
     */
    public addNewVendor(tag: string) {
      this.source.addItem({ name: tag, internalId: --this.newInternalId } as IOrganization);
      this.val = this.newInternalId;
    }
  }
